type BrandedString<Prefix extends string> = string & {
  readonly __prefixedIdBrand: Prefix;
};

export type PrefixedIdDefinition<Id extends string> = ((id: string) => Id) & {
  readonly is: (id: string) => id is Id;
  readonly strip: (id: string) => string;
  readonly create: (id: string) => Id;
};

export type PrefixedId<T> = T extends PrefixedIdDefinition<infer Id>
  ? Id
  : never;

export const PrefixedId = <const Prefix extends string>(
  prefix: Prefix
): PrefixedIdDefinition<BrandedString<Prefix>> => {
  type Id = BrandedString<Prefix>;

  const is = (id: string): id is Id => id.startsWith(prefix);

  const create = (id: string): Id => {
    if (is(id)) {
      return id;
    }
    return `${prefix}${id}` as Id;
  };

  const strip = (id: string): string => {
    if (!is(id)) {
      return id;
    }
    return id.slice(prefix.length);
  };

  return Object.assign(create, { is, strip, create });
};
